import { render, staticRenderFns } from "./CommonStatementDocument.vue?vue&type=template&id=7c38163e&scoped=true"
import script from "./CommonStatementDocument.vue?vue&type=script&lang=js"
export * from "./CommonStatementDocument.vue?vue&type=script&lang=js"
import style0 from "./CommonStatementDocument.vue?vue&type=style&index=0&id=7c38163e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c38163e",
  null
  
)

export default component.exports